
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, UserRole } from '@/contexts/AuthContext';

export function useRoleGuard(allowedRoles: UserRole[] = []) {
  const { userRole, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Only check after authentication state is loaded
    if (!isLoading) {
      // Not authenticated
      if (!isAuthenticated) {
        navigate("/login", { 
          replace: true, 
          state: { 
            message: "Bitte melden Sie sich an, um auf diese Seite zuzugreifen.",
            from: window.location.pathname // Store the current path to redirect back after login
          } 
        });
        return;
      }
      
      // No role restrictions, but must be authenticated
      if (allowedRoles.length === 0) {
        return;
      }
      
      // User doesn't have required role
      if (userRole && !allowedRoles.includes(userRole)) {
        navigate("/unauthorized", { 
          replace: true, 
          state: { 
            message: `Sie haben nicht die erforderlichen Berechtigungen (${userRole}) für den Zugriff auf diese Seite.`,
            requiredRoles: allowedRoles,
            currentUrl: window.location.pathname
          } 
        });
        return;
      }
    }
  }, [isLoading, isAuthenticated, userRole, allowedRoles, navigate]);
  
  return { isLoading, isAuthenticated, userRole };
}
